import { InfoLatealFuncionariosComponent } from "../../../componentes/InfoLateralFuncionariosComponent/InfoLateralFuncionariosComponent";
import BaseMenuPrincipal from "../../../componentes/BaseMenuPrincipalComponent/BaseMenuPrincipal";


const Funcionarios = () => {

    return (
        <>
            <BaseMenuPrincipal
                InfoLateral={<InfoLatealFuncionariosComponent />}
            />
            
            
        </>
    );
};

export default Funcionarios;